export type ParticipantPerson = {
  passportId: string;
  name: string;
  nickName?: string;
  departmentName: string;
  divisionName: string;
  positionName: string;
  profileImageUrl: string;
};

/**
 * 외부 참석자를 프로필 표시용 Person 목록으로 맞춘다.
 * 회의록 API 는 external 을 이름 배열로 주고, 생략 저장된 문서는 null 로 준다.
 */
export const toExternalPersons = (
  external: ParticipantPerson[] | string[] | null | undefined,
): ParticipantPerson[] => {
  if (!external || external.length === 0) return [];
  if (typeof external[0] !== 'string') return external as ParticipantPerson[];

  return (external as string[]).map((name, idx) => ({
    passportId: `external-${idx}`,
    name,
    nickName: '',
    departmentName: '',
    divisionName: '',
    positionName: '',
    profileImageUrl: '',
  }));
};
